export const VALIDATION_KEYS = {
  // 🌐 GENÉRICOS (Reutilizables en toda la app)
  GENERIC: {
    REQUIRED: "VALIDATION.GENERIC.REQUIRED",
    INVALID_FORMAT: "VALIDATION.GENERIC.INVALID_FORMAT",
    INVALID_URL: "VALIDATION.GENERIC.INVALID_URL",
    INVALID_EMAIL: "VALIDATION.GENERIC.INVALID_EMAIL",
    INVALID_COLOR: "VALIDATION.GENERIC.INVALID_COLOR",
    UUID: "VALIDATION.GENERIC.UUID",
    NUMBER_POSITIVE: "VALIDATION.GENERIC.NUMBER_POSITIVE",
    NUMBER_NEGATIVE: "VALIDATION.GENERIC.NUMBER_NEGATIVE",
  },

  // 📅 DISPONIBILIDAD (Específicos)
  AVAILABILITY: {
    INVALID_DAY: "VALIDATION.AVAILABILITY.INVALID_DAY",
    INVALID_DATE: "VALIDATION.AVAILABILITY.INVALID_DATE",
    TIME_ORDER: "VALIDATION.AVAILABILITY.TIME_ORDER",
    TIME_FORMAT: "VALIDATION.AVAILABILITY.TIME_FORMAT",
  },

  // 📅 EXCEPTION (Específicos)
  EXCEPTION: {
    INVALID_DATE: "VALIDATION.EXCEPTION.INVALID_DATE",
    DATE_ORDER: "VALIDATION.EXCEPTION.DATE_ORDER",
    TIME_ORDER: "VALIDATION.EXCEPTION.TIME_ORDER",
    TIME_FORMAT: "VALIDATION.EXCEPTION.TIME_FORMAT",
  },

  // 📅 EXCEPTION (Específicos)
  BLOCKED: {
    INVALID_DATE: "VALIDATION.BLOCKED.INVALID_DATE",
    DATE_ORDER: "VALIDATION.BLOCKED.DATE_ORDER",
    TIME_ORDER: "VALIDATION.BLOCKED.TIME_ORDER",
    TIME_FORMAT: "VALIDATION.BLOCKED.TIME_FORMAT",
  },

  // 👤 PACIENTES
  PATIENT: {
    NAME_REQUIRED: "VALIDATION.PATIENT.NAME_REQUIRED",
    ID_FORMAT: "VALIDATION.PATIENT.ID_FORMAT",
    INVALID_AGE: "VALIDATION.PATIENT.INVALID_AGE",
    MAX_LENGTH: "VALIDATION.PATIENT.MAX_LENGTH",
  },
  // 👤 PROFESIONALES
  PROFESSIONAL: {
    NAME_REQUIRED: "VALIDATION.PROFESSIONAL.NAME_REQUIRED",
    ID_FORMAT: "VALIDATION.PROFESSIONAL.ID_FORMAT",
    INVALID_AGE: "VALIDATION.PROFESSIONAL.INVALID_AGE",
    INVALID_SPECIALTY: "VALIDATION.PROFESSIONAL.INVALID_SPECIALTY",
    BIO_MAX_LENGTH: "VALIDATION.PROFESSIONAL.BIO_MAX_LENGTH",
    DEGREE_MAX_LENGTH: "VALIDATION.PROFESSIONAL.DEGREE_MAX_LENGTH",
  },
  CLINIC: {
    NAME_REQUIRED: "VALIDATION.CLINIC.NAME_REQUIRED",
    SLUG_REQUIRED: "VALIDATION.CLINIC.SLUG_REQUIRED",
    ADDRESS_REQUIRED: "VALIDATION.CLINIC.ADDRESS_REQUIRED",
    TAX_ID_REQUIRED: "VALIDATION.CLINIC.TAX_ID_REQUIRED",
    INVALID_TAX_ID: "VALIDATION.CLINIC.INVALID_TAX_ID",
  },
  EXERCISE_CATEGORY: {
    NAME_REQUIRED: "VALIDATION.EXERCISE_CATEGORY.NAME_REQUIRED",
    MAX_LENGTH: "VALIDATION.EXERCISE_CATEGORY.MAX_LENGTH",
  },
  EXERCISE: {
    NAME_REQUIRED: "VALIDATION.EXERCISE.NAME_REQUIRED",
    URL_REQUIRED: "VALIDATION.EXERCISE.URL_REQUIRED",
  },
  PROTOCOL: {
    NAME_REQUIRED: "VALIDATION.PROTOCOL.NAME_REQUIRED",
    INVALID_EXERCISE: "VALIDATION.PROTOCOL.INVALID_EXERCISE",
    SERIES_MIN_LENGTH: "VALIDATION.PROTOCOL.SERIES_MIN_LENGTH",
    REPS_REQUIRED: "VALIDATION.PROTOCOL.REPS_REQUIRED",
    FREQUENCY_REQUIRED: "VALIDATION.PROTOCOL.FREQUENCY_REQUIRED",
    EXERCISES_MIN_LENGTH: "VALIDATION.PROTOCOL.EXERCISES_MIN_LENGTH",
  },
  INVOICE: {
    INVALID_UUID: "VALIDATION.INVOICE.INVALID_UUID",
  },
  SERVICE_CATEGORY: {
    NAME_REQUIRED: "VALIDATION.SERVICE_CATEGORY.NAME_REQUIRED",
    MAX_LENGTH: "VALIDATION.SERVICE_CATEGORY.MAX_LENGTH",
  },
  SERVICE: {
    NAME_REQUIRED: "VALIDATION.SERVICE.NAME_REQUIRED",
    DURATION_REQUIRED: "VALIDATION.SERVICE.DURATION_REQUIRED",
    REAL_PRICE: "VALIDATION.SERVICE.REAL_PRICE",
  },
  SPECIALTY: {
    NAME_REQUIRED: "VALIDATION.SPECIALTY.NAME_REQUIRED",
    MAX_LENGTH: "VALIDATION.SPECIALTY.MAX_LENGTH",
  },
  STAFF: {
    ROLE: "VALIDATION.STAFF.ROLE",
    NAME_REQUIRED: "VALIDATION.STAFF.NAME_REQUIRED",
    ID_FORMAT: "VALIDATION.STAFF.ID_FORMAT",
    INVALID_AGE: "VALIDATION.STAFF.INVALID_AGE",
  },
} as const;
